module.exports = __webpack_public_path__ + "media/images/xleague_logo-0075e224006c066ab77d462151e9c236.png";